import { render, staticRenderFns } from "./OrderHistoryCard.vue?vue&type=template&id=7c1c8fe5&scoped=true&"
import script from "./OrderHistoryCard.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryCard.vue?vue&type=style&index=0&id=7c1c8fe5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c8fe5",
  null
  
)

export default component.exports